import React, { useState } from 'react'
import { PartnerAdvertiserInvite, ResendPartnerAdvertiserInviteMutation, useResendPartnerAdvertiserInviteMutation } from 'generated/graphql'
import { useTranslation } from 'react-i18next'
import { LoadingTextButton } from '@amzn/aapn-react-components'
import { ExecutionResult } from 'graphql'
import { StyledInlineMessage } from '../../manage_shared.styles'
import { PARTNER_ID_HEADER_KEY } from 'util/app_initialization/apollo_client/stagedive_apollo_client_provider'
import * as i18nKeyList from './link_advertisers_v2_i18n_mappings'

interface AdvertiserInvitesResendProps {
  inviteToken: string
  partnerId: string
  onSetData: (newInvite: PartnerAdvertiserInvite) => void
}

export const AdvertiserInvitesResend: React.FunctionComponent<AdvertiserInvitesResendProps> = (props: AdvertiserInvitesResendProps): JSX.Element => {
  const { inviteToken, partnerId, onSetData } = props
  const [resendError, setResendError] = useState(false)
  const { t } = useTranslation()
  const [resendInvite, { data: resendData, loading: resendLoading }] = useResendPartnerAdvertiserInviteMutation()

  return (
    <>
      <LoadingTextButton
        isLoading={resendLoading}
        sendLabel={t(i18nKeyList.RESEND_ADVERTISER_LABEL)}
        loadingLabel={t(i18nKeyList.RESEND_ADVERTISER_LOADING_LABEL)}
        isDisabled={false}
        onClickSend={() => {
          const resendInvitePromise = resendInvite({
            variables: {
              inviteId: inviteToken,
            },
            context: {
              headers: {
                [PARTNER_ID_HEADER_KEY]: partnerId,
              },
            },
          }).then((response: ExecutionResult<ResendPartnerAdvertiserInviteMutation>) => {
            onSetData(response?.data?.resendPartnerAdvertiserInvite as PartnerAdvertiserInvite)
            setResendError(false)
          })
          resendInvitePromise.catch(() => {
            setResendError(true)
          })
        }}
      />
      {resendError && <StyledInlineMessage messageType={'error'} message={t(i18nKeyList.RESEND_ADVERTISER_ERROR)} />}
      {!!resendData && <StyledInlineMessage messageType={'success'} message={t(i18nKeyList.RESEND_ADVERTISER_SUCCESS)} />}
    </>
  )
}
